import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import styles from './AppShell.module.css';

const NAV: Array<{ to: string; label: string; end: boolean; icon: string }> = [
  { to: '/', label: 'Обзор', end: true, icon: '◉' },
  { to: '/bookings', label: 'Заявки', end: false, icon: '▤' },
  { to: '/prices', label: 'Цены', end: false, icon: '₽' },
  { to: '/account', label: 'Аккаунт', end: false, icon: '◔' },
];

export function AppShell() {
  const { admin, logout } = useAuth();

  return (
    <div className={styles.root}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <div>
            <div className={styles.brandName}>Хутор Кедровый</div>
            <div className={styles.brandSub}>Админка</div>
          </div>
        </div>

        <nav>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `${styles.link} ${isActive ? styles.linkActive : ''}`
              }
            >
              <span style={{ width: 16, textAlign: 'center' }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className={styles.spacer} />

        {admin && (
          <div className={styles.user}>
            <div className={styles.userName}>{admin.name}</div>
            <div>{admin.username}</div>
            <button type="button" className={styles.logout} onClick={() => void logout()}>
              Выйти
            </button>
          </div>
        )}
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>

      <nav className={styles.mobileBar} aria-label="Мобильная навигация">
        <div className={styles.mobileBarInner}>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ''}`
              }
            >
              <span style={{ fontSize: 16 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
